import type { Env, VpnGatewayRecord, VpnPeerStatus } from '@fleet-cert-console/shared';

/** Demo VPN gateway rows (fixture mode). */
export const VPN_FIXTURE: Record<Env, VpnGatewayRecord[]> = {
  dev: [
    {
      gatewayId: '647fdafffe0117df',
      hostname: 'kona-enterprise-0117DF',
      groupId: 'default',
      vpnStatus: 'applied',
      vpnIp: '100.100.1.2',
      vpnDnsName: '647fdafffe0117df.vpn.dev.iotsimplelink.com',
      gatewayPubKey: 'DEMOPUBKEYdGVrdGVsaWMga29uYSBkZW1vIGtleQ=',
      updatedAt: new Date().toISOString(),
      // Link control (gateway-reported): a healthy 2.2.0 Kona with autostart on.
      vpnLinkState: 'up',
      vpnLinkConnected: true,
      vpnLinkHandshakeAgoSec: 12,
      vpnAutostart: true,
      vpnHeld: false,
      vpnSupervisorRunning: true,
      vpnLinkUpdatedAt: new Date(Date.now() - 90_000).toISOString(),
      vpnClientVersion: '2.2.0',
      gatewayFirmwareVersion: '7.2.8',
      forwarderVersion: '4.5.1-r1',
      gatewayVendor: 'tektelic-kona',
      vpnLinkLastAction: 'status',
      vpnLinkLastActionAt: new Date(Date.now() - 100_000).toISOString(),
      vpnLinkLastExecId: 41,
      vpnLastExecId: 41,
    },
    {
      gatewayId: 'a84041fffe1b2c3d',
      hostname: 'dragino-dlos8n-1b2c3d',
      groupId: 'default',
      vpnStatus: 'requested',
      gatewayPubKey: 'DEMOPUBKEYZHJhZ2lubyBkbG9zOG4gZGVtbyBrZXk=',
      updatedAt: new Date().toISOString(),
    },
    {
      // Provisioned by the bench, never enrolled: what #39 adds (fleet index, no VPN row).
      gatewayId: '647fdafffe019bec',
      provisioning: {
        status: 'COMPLETE',
        confirmedAt: new Date(Date.now() - 3_600_000).toISOString(),
        customer: '900',
        project: '999',
        thingTypeName: 'LoRaWANGateway',
      },
    },
  ],
  prod: [],
};

/** Demo live peer state (fixture mode): the applied kona is online (fresh handshake). */
export const VPN_PEER_STATUS_FIXTURE: Record<Env, VpnPeerStatus[]> = {
  dev: [
    {
      publicKey: 'DEMOPUBKEYdGVrdGVsaWMga29uYSBkZW1vIGtleQ=',
      endpoint: '203.0.113.5:51820',
      allowedIps: ['100.100.1.2/32'],
      latestHandshakeAt: new Date(Date.now() - 40_000).toISOString(),
      rxBytes: 18_734_221,
      txBytes: 4_112_009,
    },
  ],
  prod: [],
};
